import ApiConfig from "../Config";
import apiService from "../services/apiService";

const homeService = {
  getBaner: () => apiService.get(ApiConfig.getBanner),
  setVisibilityBanner: (isVisible, bannerId) =>
    apiService.post(
      ApiConfig.setVisibiltyBanner,
      {},
      {
        headers: {
          "banner-id": bannerId,
          "is-visible": !isVisible,
        },
      },
    ),

  deleteBanner: (bannerId) =>
    apiService.delete(ApiConfig.deleteBanner, {
      headers: {
        "banner-id": bannerId,
      },
    }),

  addBanner: (bannerData) =>
    apiService.post(ApiConfig.addBanner, bannerData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
};
export default homeService;
